module.exports = __webpack_public_path__ + "static/media/loader_transparent.2d48fae5.gif";